import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App";
import { Provider } from "react-redux";
import { legacy_createStore as createStore } from "redux";
import commonBus from "./js/reducers";

// Handle chunk loading errors by reloading the page
// This occurs when a new deployment happens and old chunks are no longer available
window.addEventListener("error", event => {
	const message = event.message || "";
	const filename = event.filename || "";
	
	// Check if it's a chunk-related error (syntax errors from loading HTML as JS, or missing chunks)
	if (
		(message.includes("Unexpected token") && /\d+-[a-f0-9]+.*\.js/.test(filename)) ||
		filename.includes("chunk")
	) {
		event.preventDefault();
		window.location.reload();
	}
});

let store = createStore(commonBus);

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<div>
				<App />
			</div>
		</BrowserRouter>
	</Provider>
);
